import { render, staticRenderFns } from "./MediaChangeRejectDialog.vue?vue&type=template&id=200a678a"
import script from "./MediaChangeRejectDialog.vue?vue&type=script&lang=ts"
export * from "./MediaChangeRejectDialog.vue?vue&type=script&lang=ts"
import style0 from "./MediaChangeRejectDialog.vue?vue&type=style&index=0&id=200a678a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports